import { IComponentOptions, IFormController, IOnChanges, IOnChangesObject } from "angular";
import { EventEmitter } from "../../../common/components/event-emitter";
import templateUrl from "./change-direct-deposit.component.html";
import { DepositAmountType } from "./deposit-amount-type";
import { BankAccount, DirectDepositInformation } from "./bank-account";
import { BankAccountCreationPolicy } from "../../../core/services";

export const ChangeDirectDepositComponent: IComponentOptions = {
    templateUrl,
    require: {
        editForm: "^^form"
    },
    bindings: {
        account: "<",
        identity: "<",
        depositAmountTypes: "<",
        bankAccountCreationPolicy: "<",
        changeAccount: "&onChangeAccount"
    },
    controller: class ChangeDirectDepositComponent implements IOnChanges {
        editForm: IFormController;
        account: DirectDepositAccount;
        depositAmountTypes: DepositAmountType[];
        voidCheck: File;
        adpDirectDeposit: File;
        changeAccount: EventEmitter<{ account: UpdatedDirectDeposit }>;
        bankAccountCreationPolicy: BankAccountCreationPolicy;

        $onChanges(changesObj: IOnChangesObject) {
            if (changesObj.account) {
                // Create a reference clone of the new account object.
                this.account = { ...this.account }
            } else {
                if (changesObj.depositAmountTypes) {
                    // Clear the deposit amount type.
                    this.account.depositAmountTypeID = null;
                }
            }
        }

        onChangeAccount() {
            this.changeAccount({
                $event: {
                    account: {
                        bankAccountID: this.account.bankAccountID,
                        depositAmount: this.account.depositAmount,
                        depositAmountTypeID: this.account.depositAmountTypeID,
                        voidCheck: this.voidCheck,
                        adpDirectDeposit: this.adpDirectDeposit
                    }
                }
            })
        }
    }
};

/** The input model unifies the bank account with a single editable direct deposit option. */
export interface DirectDepositAccount extends BankAccount, DirectDepositInformation {
    bankAccountID: number;
    voidCheckUrl: string;
    adpDirectDepositUrl: string;
}

export interface UpdatedDirectDeposit {
    bankAccountID: number;
    depositAmountTypeID: number;
    depositAmount: number;
    voidCheck: File;
    adpDirectDeposit: File;
}
